import StarIcon from '@mui/icons-material/Star'
import {CircularProgress} from '@mui/material'
import Button from '@mui/material/Button'
import {grey} from '@mui/material/colors'
import {IPerson} from 'app/models/person'
import {IBusiness, IConcept} from 'app/models/user'
import {UserProfile, useAuthProvider} from 'app/modules/auth'
import {IfeFavorites} from 'interfaces/IfeFavorites'
import React, {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import {updateUserAsncThunk} from 'redux/actions/userActions'
import {AppDispatch} from 'redux/store'
import toastr from 'toastr'

interface Props {
  item: IPerson | IBusiness | IConcept
  type: 'businesses' | 'concepts' | 'people' | 'awards' | 'innovations' | 'opportunities'
}

export default function FavoriteButton({item, type}: Props) {
  const dispatch = useDispatch<AppDispatch>()
  const {reduxUser} = useAuthProvider()
  const userProfile =
    reduxUser && reduxUser.profile && Object.keys(reduxUser.profile).length !== 0
      ? {...(reduxUser.profile as UserProfile)}
      : reduxUser?.profile ?? {
          first_name: '',
          last_name: '',
          address_line1: '',
          address_line2: '',
          address_city: '',
          address_state: '',
          address_zip: '',
          address_single_line: '',
          work_phone: '',
          mobile_phone: '',
          linkedin_url: '',
          twitter_url: '',
          is_public: false,
          is_searchable: false,
          full_name: '',
          profile_email: '',
          favorites: {},
        }

  const [userId, setUserId] = React.useState<string>(reduxUser?.id ?? '')
  const [favoriting, setFavoriting] = React.useState(false)

  const onToggleFavorited = useCallback(() => {
    if (!item || !userProfile || !userId) {
      //make a profile if not one, the useeffect should set the userId when this post completes
      return
    }

    if (userProfile) {
      const copyProfile = {...(userProfile ?? {})}
      setFavoriting(true)
      const favorites: IfeFavorites | undefined = {...(copyProfile?.favorites ?? undefined)}
      let favs: any[] = []
      //check if exist

      if (favorites?.[type]) {
        //is it already favorited then remove it
        if (favorites[type]?.find((id) => id === item.id)) {
          favs = favorites[type]?.filter((id) => id !== item.id) ?? []
        } else {
          //not favorited so set it, then add it
          favs = favorites[type] ?? []
          favs = [...favs, item.id ?? '']
        }
      } else {
        favs = [...favs, item.id ?? '']
      }
      if (favorites) {
        favorites[type] = favs
        //set profile
        copyProfile.favorites = favorites
        try {
          // await updateProfile.mutateAsync({
          //   userId: userId,
          //   rel: 'user',
          //   profile: userProfile,
          // })
          reduxUser &&
            dispatch(
              updateUserAsncThunk({
                id: userId,
                updateUserPart: {profile: copyProfile},
                originalUser: reduxUser,
              })
            )
        } catch (error) {
          console.warn(error)
          toastr.error(error?.response?.data?.error)
        } finally {
          setFavoriting(false)
        }
      }
    }
  }, [item, userProfile, userId])

  return (
    <Button
      sx={{color: grey[300]}}
      disabled={favoriting}
      onClick={() => {
        onToggleFavorited()
      }}
    >
      {favoriting ? (
        <>
          <CircularProgress size={'sm'} />
        </>
      ) : (
        <>
          {!userProfile?.favorites?.[type]?.find((f) => f === item.id) ? (
            <StarIcon fontSize='large' color={'inherit'} />
          ) : (
            <StarIcon fontSize='large' color={'warning'} />
          )}
        </>
      )}
    </Button>
  )
}
